import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { OnlineProvider } from "./context/OnlineContext";
import { DashboardTutorialProvider } from './context/DashboardTutorialContext';
import { AccountTutorialProvider } from './context/AccountTutorialContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <BrowserRouter>
      <OnlineProvider>
        {/* <DashboardTutorialProvider>*/}
           <AccountTutorialProvider> 
          <App />
           </AccountTutorialProvider>
        {/*</DashboardTutorialProvider> */}
      </OnlineProvider>
    </BrowserRouter>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
